import { globalSettingModel } from '@models/global-setting.model';
import { useModel } from 'foca';
import { type FC } from 'react';
import styles from './setting-rpc.module.scss';
import DownIcon from '@assets/images/header/down.svg';
import { startCase } from 'lodash-es';
import SettingRpcContent from './setting-rpc-content';
import { useToggle } from 'react-use';
import Dropdown from '@ui/parrot/dropdown';

const SettingRpc: FC = () => {
  const rpcKey = useModel(globalSettingModel, (state) => state.rpcKey);
  const [selecting, toggleSelecting] = useToggle(false);

  return (
    <div className={styles.line}>
      <div className={styles.left}>RPC</div>
      <Dropdown
        onOpenChange={toggleSelecting}
        trigger={['click']}
        placement="bottomRight"
        destroyPopupOnHide={true}
        dropdownRender={() => (
          <SettingRpcContent toggleSelecting={toggleSelecting} visible={selecting} />
        )}
        open={selecting}
      >
        <div className={`${styles.right} ${selecting ? styles.active : ''}`}>
          <span>{startCase(rpcKey)}</span>
          <img src={DownIcon} />
        </div>
      </Dropdown>
    </div>
  );
};

export default SettingRpc;
